export default (state, action) => ({
  ...state,
  hasGlobalError: true,
  errorMessage: action.errorMessage,
  reloadOnGlobalError: action.reloadOnClose,
});
